// @flow
import React, { Fragment } from 'react';
import { Small } from '@finect/tabular-core/Small';
import { ArrowLeft } from '@finect/tabular-icons/arrowLeft';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { PageNumberLink, PageNavigation, MovePageLink, PageMore, CurrentPageLink } from './partials';

type Props = {
  basePath: string,
  items: number,
  currentPage: number,
  pages: number,
  pageLength: number,
  name: string
};

export const Pagination = ({ basePath, items, currentPage, pages, pageLength, name }: Props) => {
  const iconProps = { size: '20' };

  const limitDown = (currentPage - 1) * pageLength + 1;
  const limitUp = currentPage === pages ? items : currentPage * pageLength;
  const prev = currentPage - 1;
  const next = currentPage + 1;

  return (
    <PageNavigation>
      {currentPage > 1 ? (
        <MovePageLink rel="prev" to={`${basePath}${prev > 1 ? `?pagina=${prev}` : ''}`}>
          <ArrowLeft {...iconProps} />
        </MovePageLink>
      ) : null}
      {currentPage !== 1 ? (
        <Fragment>
          <PageNumberLink to={basePath}>1</PageNumberLink>
          {currentPage !== 2 ? <PageMore>…</PageMore> : null}
        </Fragment>
      ) : null}
      <CurrentPageLink
        rel="canonical"
        href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}${basePath}${
          currentPage > 1 ? `?pagina=${currentPage}` : ''
        }`}
        selected
      >
        {currentPage}
      </CurrentPageLink>
      {currentPage !== pages ? (
        <Fragment>
          {currentPage !== pages - 1 ? <PageMore>…</PageMore> : null}
          <PageNumberLink to={`${basePath}?pagina=${pages}`}>{pages}</PageNumberLink>
        </Fragment>
      ) : null}
      {currentPage < pages ? (
        <MovePageLink rel="next" to={`${basePath}?pagina=${next}`}>
          <ArrowRight {...iconProps} />
        </MovePageLink>
      ) : null}
      <Small light>
        ({limitDown} {limitDown < limitUp ? `– ${limitUp}` : null} de {items} {name})
      </Small>
    </PageNavigation>
  );
};
